import React, {useEffect, useRef} from "react";
import useUrlHash from "@hooks/useUrlHash";
import PracticeQuestionsCore from "./PracticeQuestionsCore";

const PracticeQuestions = props => {
    const {conceptId, hashName, callback} = props;
    const {hashSegments, updateHash} = useUrlHash();
    const levelFromUrl = hashSegments[0] === hashName ? hashSegments[1] : null;
    const callbackRef = useRef(callback);

    useEffect(() => { callbackRef.current = callback; });

    useEffect(() => {
        callbackRef.current?.();
    }, []);

    const handleLevelChange = level => {
        if (hashName) {
            const targetHash = level ? `${hashName}/${level}` : hashName;
            updateHash(targetHash);
        }
    }

    return (
        <PracticeQuestionsCore
            conceptId={conceptId}
            questionLevel={levelFromUrl}
            onLevelChange={handleLevelChange}
        />
    )
};

export default PracticeQuestions;